import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setDealStage, setDeal } from 'bundles/apex/deals/form/store/deal/actions';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';
import { getOrderedStages } from 'bundles/apex/helpers/stages';

export function DealStage({ allowStageChange, allStages, deal, setDealStage, setDeal }) {
  // This component is only used for deal creation, and deals can not be created as dead
  const stages = { ...allStages };
  delete stages.dead;

  if (!allowStageChange) {
    return null;
  }

  async function handleChange(value) {
    const stageConfig = allStages[value];
    if (stageConfig?.defaultCloseProbability) {
      const defaults = { closeProbability: stageConfig.defaultCloseProbability };
      setDeal({ ...deal, ...defaults });
    }
    setDealStage(value);
  }

  return (
    <ManagedFormGroup
      includeBlank
      label="Deal Stage"
      required
      type="select"
      value={deal.stage}
      onValueChange={handleChange}
    >
      <Options options={Object.values(getOrderedStages(stages))} valueName="key" />
    </ManagedFormGroup>
  );
}

DealStage.propTypes = {
  allowStageChange: PropTypes.bool,
  allStages: PropTypes.object.isRequired,
  deal: PropTypes.shape({
    stage: PropTypes.string.isRequired,
  }).isRequired,
  setDeal: PropTypes.func.isRequired,
  setDealStage: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  allowStageChange: state.allowStageChange,
  deal: state.deal,
  allStages: state.stagesConfig,
});

const mapDispatchToProps = {
  setDeal,
  setDealStage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealStage);
